import { Breadcrumb, Button, Modal, Typography } from "antd";
import { useForm } from "antd/es/form/Form";
import { useState } from "react";
import { PlusOutlined } from "@ant-design/icons";
import { AddEditPostTypeForm } from "../components/AddEditPostTypeForm";
import { PostTypeList } from "../components/PostTypeList";
import { PostTypeFilter } from "../components/PostTypeFilter";
import { usePostTypes } from "../../../../hooks/usePostType";

const { Title } = Typography;

export function PostTypesPage() {
  const [open, setOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [form] = useForm();
  const [filter, setFilter] = useState({ page: 1, limit: 100 });
  const { data, loading, create, update, remove } = usePostTypes(filter);

  const handleAdd = () => {
    setSelectedItem(null);
    form.resetFields();
    setOpen(true);
  };

  const handleEdit = (item) => {
    setSelectedItem(item);
    form.setFieldsValue(item);
    setOpen(true);
  };

  const handleDelete = async (id) => {
    await remove.mutateAsync(id);
  };

  const handleSubmit = async (values) => {
    if (selectedItem) {
      await update.mutateAsync({ ...values, _id: selectedItem._id });
    } else {
      await create.mutateAsync(values);
    }
    setOpen(false);
    form.resetFields();
  };

  const handleFilterChange = (newFilter) => {
    setFilter(newFilter);
  };

  return (
    <div style={{ padding: 24 }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div>
          <Breadcrumb
            items={[{ title: "Bảng điều khiển" }, { title: "Loại tin tức" }]}
          />
          <Title level={3} style={{ margin: 0 }}>
            Quản lý loại tin tức
          </Title>
        </div>
        <Button type="primary" icon={<PlusOutlined />} onClick={handleAdd}>
          Thêm loại tin tức
        </Button>
      </div>

      <div style={{ padding: "24px 0" }}>
        <PostTypeFilter filter={filter} onFilterChange={handleFilterChange} />
      </div>

      <div>
        <PostTypeList
          data={data}
          loading={loading}
          filter={filter}
          onFilterChange={handleFilterChange}
          onEdit={handleEdit}
          onDelete={handleDelete}
        />
      </div>
      <Modal
        title={selectedItem ? "Cập nhật loại tin tức" : "Thêm loại tin tức"}
        open={open}
        onCancel={() => setOpen(false)}
        footer={null}
      >
        <AddEditPostTypeForm
          form={form}
          loading={create.isPending || update.isPending}
          onSubmit={handleSubmit}
        />
      </Modal>
    </div>
  );
}
